import { injectable } from 'inversify'
import type { HttpRequestContext } from '../Utils/HttpRequestContext'
import { DomainService } from './DomainService'
import { ReplacingConfigurationModel } from './ReplacingConfigurationModel'

@injectable()
export class ReplaceDomainService implements DomainService {
  configuration: ReplacingConfigurationModel
  constructor(private httpRequestContext: HttpRequestContext) {
    this.configuration = this.getConfig()
  }

  replaceDomain(inputString: string): string {
    if (
      this.configuration.inputDomains == null ||
      this.configuration.inputDomains.length == 0 ||
      this.configuration.outputDomains == null ||
      this.configuration.outputDomains.length == 0
    ) {
      return inputString
    }

    let stringToReplace = inputString
    stringToReplace = this.prepareExcludedDomains(this.configuration, stringToReplace)
    stringToReplace = this.replaceDomains(this.configuration, stringToReplace)
    stringToReplace = this.restoreExcludedDomains(this.configuration, stringToReplace)

    return stringToReplace.toString()
  }

  prepareExcludedDomains(configuration: ReplacingConfigurationModel, stringToReplace: string): string {
    let resultString = stringToReplace
    for (const domainToExclude of configuration.excludedDomains) {
      const domainToExcludeModified = domainToExclude.replaceAll('.', '..')
      resultString = resultString.replaceAll(domainToExclude, domainToExcludeModified)
    }
    return resultString
  }

  replaceDomains(configuration: ReplacingConfigurationModel, stringToReplace: string): string {
    let resultString = stringToReplace
    for (let replaceIndex = 0; replaceIndex < configuration.inputDomains.length; replaceIndex++) {
      resultString = resultString.replaceAll(
        configuration.inputDomains[replaceIndex],
        configuration.outputDomains[replaceIndex]
      )
    }
    return resultString
  }

  replaceDomainsFromObject(inputObject: { [key: string]: unknown }): unknown {
    if (!inputObject) {
      return
    }

    Object.entries(inputObject).forEach(([key, value]) => {
      if (!value) {
        return
      }

      if (typeof value === 'string') {
        inputObject[key] = this.replaceDomain(value)
      } else if (typeof value === 'object') {
        if (Array.isArray(value)) {
          if (value[0] && typeof value[0] === 'string') {
            const newArray = value.map((item) => this.replaceDomain(item))
            inputObject[key] = newArray
          } else {
            value.map((item) => this.replaceDomainsFromObject(item))
          }
        } else {
          this.replaceDomainsFromObject(value as { [key: string]: unknown })
        }
      }
    })

    return inputObject
  }

  restoreExcludedDomains(configuration: ReplacingConfigurationModel, stringToReplace: string): string {
    let resultString = stringToReplace
    for (const domainToExclude of configuration.excludedDomains) {
      const domainToExcludeModified = domainToExclude.replaceAll('.', '..')
      resultString = resultString.replaceAll(domainToExcludeModified, domainToExclude)
    }
    return resultString
  }

  getConfig(): ReplacingConfigurationModel {
    const result: ReplacingConfigurationModel = { inputDomains: [], outputDomains: [], excludedDomains: [] }

    const inputDomains = this.httpRequestContext.replaceDomains.inputDomains
    const outputDomains = this.httpRequestContext.replaceDomains.outputDomains
    const excludedDomains = this.httpRequestContext.replaceDomains.excludedDomains

    if (!inputDomains || !outputDomains) {
      return result
    }

    result.inputDomains = inputDomains
    result.outputDomains = outputDomains

    if (excludedDomains) {
      result.excludedDomains = excludedDomains
    } else {
      result.excludedDomains = []
    }

    if (
      result.inputDomains.length == 0 ||
      result.outputDomains.length == 0 ||
      result.inputDomains.length != result.outputDomains.length
    ) {
      result.inputDomains = []
      result.outputDomains = []
      result.excludedDomains = []

      return result
    }

    return result
  }
}

//  DON'T DELETE - used by DW
